import React, { Children, Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../../../helpers/functions';
import { ListComponent, FilterDropdown, StatusComponent } from "../../../../common/component/Index";
import TagGroupDetail from './../../../../../../models/TagGroupDetail';
import { withTranslation } from "react-i18next";
import { Icon, Rate, Menu, Tooltip, Tag } from 'antd';
import Span from '../../../../common/component/Span';
import Wrapper from '../../../../common/component/Wrapper';
import Dropdown from '../../../../common/component/Dropdown';
import Modal from '../../../../common/component/Modal';
import { PATHS, TOUR } from '../../../../../../constants/Define';
import './TagGroupDetailList.less';
import { FlagIcons } from '../../../../common/component/TranslateButton';
import EllipsisText from '../../../../common/component/EllipsisText';
import TagItem from '../../../../common/component/TagItem';
import featureFlags from '../../../../../../constants/featureFlags';
import { groupBy, toArray } from 'lodash';

const ListCols = [
    'name', 'order', 'linkedSkus', 'tagGroupId', 'status', 'translations'
];
const ModelFields = Object.getOwnPropertyNames(new TagGroupDetail());
class TagGroupDetailList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            titleItemTable: Func.getTitleTable(ListCols, ['action'], []),
            modelItem: ModelFields,
            componentTable: {
                name: {
                    sorter: (i, k) => i.name.length - k.length,
                    key: 'name',
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                        >
                        </FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                    render: (text, record) => (
                        <Tooltip title={record.color}>
                            <TagItem
                                label={record.name}
                                color={record.color}
                                backgroundColor={record.bgColor}
                            />
                        </Tooltip>
                    )
                },
                linkedSkus: {
                    render: (value, record) => record.tagGroupDetailSkus ? record.tagGroupDetailSkus.length : 0
                },
                status: {
                    key: 'isActive',
                    render: (text, record) => (
                        <StatusComponent color={record.isActive ? 'green' : 'red'}
                            label={record.isActive ? this.props.t('item.tagGroupDetails.active') : this.props.t('item.tagGroupDetails.deactive')} />
                    )
                },
                translations: {
                    key: 'translations',
                    width: 120,
                    render: (text, record) => <FlagIcons languages={record.translations} />,
                },
                action: {
                    // fixed: 'right',
                    width: 100,
                    align: 'center',
                    key: 'action',
                    render: (text, record) => this.renderEditComponent(record),
                }
            },
            filters: {},
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.tagGroups.length === 0 && this.props.tagGroups.length > 0) {
            const groupedDataTags = groupBy(this.props.tagGroups, 'type')
            const filterData = Object.keys(groupedDataTags).map(tagGroupTypeId => ({
                value: tagGroupTypeId, text: this.props.t(`item.tagGroupDetails.tagGroupTypes.${tagGroupTypeId}`), children: (groupedDataTags[tagGroupTypeId] || []).map(item => ({value: item.id, text: item.name}))
            }))
            this.setState({componentTable: {
                ...this.state.componentTable,
                tagGroupId: {
                    key: 'tagGroupId',
                    render: (value, record) => {
                        const tagGroup = (this.props.tagGroups || []).find(item => record.tagGroupId === item.id);
                        return tagGroup && tagGroup.name
                    },
                    filters: filterData,
                    filterMultiple: false,
                }
            }})
        }
    }

    render() {
        const { loading, pagination, tagGroupDetails } = this.props;
        const { titleItemTable, modelItem, componentTable } = this.state;
        return (
            <ListComponent
                tableKey="tour-list"
                // scroll={{ x: 1200 }}
                classParent="tour-list m-0"
                classChildren="p-0"
                rowKey={(record, k) => record.id ? record.id : k}
                loading={{ spinning: loading, size: 'large' }}
                dataSource={Func.getDataSource(tagGroupDetails || [], modelItem)}
                columns={Func.columnsTable({
                    titleTable: titleItemTable,
                    component: componentTable,
                    itemName: 'tagGroupDetails'
                })}
                onChange={this.props.onChange}
                pagination={pagination}
                componentTableList={{}}
            />
        );
    }

    renderEditComponent(item) {
        const { t, permisions } = this.props;
        return (
            <Dropdown overlay={
                <Menu className="action-menu">
                    {
                        permisions && permisions.allowView &&
                        <Menu.Item>
                            <Link to={Func.getPathWithParams(PATHS.TAG_GROUP_DETAIL.DETAIL.path, { id: item.id })} className={`mr-2`}>
                                <Icon
                                    type={permisions.allowUpdate ? "form" : "eye"}
                                    className="fs20 mr-1" />
                                {permisions.allowUpdate ? t(`action.edit`) : t(`action.show`)}
                            </Link>
                        </Menu.Item>
                    }

                    {
                        permisions && permisions.allowDelete && featureFlags.DELETE_TAG_GROUP_DETAIL_ENABLE &&
                        <Menu.Item onClick={e => this.onRemove(item)}><Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}</Menu.Item>
                    }
                </Menu>
            }>
                <Icon type="more" className="fs20 cursorPointer" />
            </Dropdown>
        )
    }

    onRemove = (item) => {
        const { t } = this.props;
        const { confirm } = Modal;
        confirm({
            title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.tagGroupDetails.title`)),
            okText: t(`action.remove`),
            cancelText: t(`action.cancel`),
            onOk: () => {
                this.props.onDelete && this.props.onDelete(item)
            },
        });
    }


}

export default withTranslation()(TagGroupDetailList);
